import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { ContentHolder } from "commons";
import { IN_PROGRESS } from "commons/src/helpers/RequestHelpers";

import { MemoAssets } from "./MemoAssets";
import { requestObject } from "../../reducers/requestsActions";

function MemoAssetsContainerComponent({ memoAssets, requestStatus }) {
    return (
        <ContentHolder>
            <MemoAssets memoAssets={memoAssets} requestStatus={requestStatus} />
        </ContentHolder>
    );
}

MemoAssetsContainerComponent.defaultProps = {
    requestStatus: {
        status: IN_PROGRESS
    }
};

MemoAssetsContainerComponent.propTypes = {
    memoAssets: PropTypes.array,
    requestStatus: requestObject
};

const mapStateToProps = state => ({
    memoAssets: state.memoAssets.assets,
    requestStatus: state.requests.memoAssets
});

export const MemoAssetsContainer = connect(mapStateToProps)(MemoAssetsContainerComponent);
